import { createFileRoute } from '@tanstack/react-router';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { NotificationListCard } from '@/features/consumer/notification-list-card';

export const Route = createFileRoute(
  '/(consumer)/_authenticated/notifications'
)({
  component: NotificationsPage,
});

function NotificationsPage() {
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>Notifications</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <NotificationListCard />
      </div>
    </div>
  );
}
